

import React, { Component } from 'react';

class GCTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editEntry: false,
            filterBy: {}, sortBy: 'name', sortOrder: 1,
            loading: false
        };
    }
    cancel = () => {
        this.setState({ editEntry: false, loading: false, error: '', alias: '', newAlias: '' })
    }

    editEntry = (entry) => e => {
        this.setState({ editEntry: true, entry: entry, loading: false, error: '' })
    }
    add = () => {
        this.setState({
            editEntry: true,
            entry: this.props.data.GCTable.settings.blank,
            loading: false,
            newEntry: true,
            error: ''
        })
    }
    handleChange = (event) => {
        const { name, type, value, checked } = event.target;
        const newValue = value;
        let error = '';

        this.setState({
            entry: {
                ...this.state.entry,
                [name]: newValue
            },
            error: error
        });
    };

    confirmEditEntry = () => {
        console.log("confirmEditEntry")
        console.log(this.state.entry)
        if (this.state.newEntry) {
            console.log("Adding new entry")
            this.props.ws.send(JSON.stringify({ route: 'addGCTable', entry: this.state.entry }))
        } else {
            this.props.ws.send(JSON.stringify({ route: 'editGCTable', entry: this.state.entry }))
        }
        this.setState({ editEntry: false, newEntry: false, loading: true, error: '', entry: {}, alias: '', newAlias: '' })
    }
    confirmDeleteEntry = () => {
        this.props.ws.send(JSON.stringify({ route: 'deleteGCTable', entry: this.state.entry }))
        this.setState({ editEntry: false, newEntry: false, loading: true, error: '', entry: {}, alias: '', newAlias: '' })
    }


    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }
    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }

    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.name > b.name ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }

    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                    return false
                }
            }
            return true
        })
    }

    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }

    render() {
        if (this.props.active) {

            // //if this.stat.type is empty, set it to user
            // if (this.state.type === "" || this.state.type === undefined) {
            //     this.setState({ type: "User" })
            // }


            var entries = JSON.parse(JSON.stringify(this.props.data.GCTable.entries));
            var settings = JSON.parse(JSON.stringify(this.props.data.GCTable.settings));
            var displayFields = settings.displayFields
            for (var field of displayFields) {
                if (settings.key === field) {
                    //Replace that item with the word key
                    displayFields[displayFields.indexOf(field)] = "key"
                }
            }
            console.log(displayFields)
            console.log(settings)
            console.log(displayFields)
            //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                entries = this.filterFunc(entries, this.state.filterBy)
            }

            //Sorting List
            if (this.state.sortBy !== '') {
                entries.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }
            entries = entries.filter((entry) => {
                return entry.type === this.state.type
            })
            var editEntry = ""
            if (this.state.editEntry) {
                console.log(this.state.entry)
                editEntry = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <h3>{this.state.newEntry ? `Entry: ${this.state.entry.key}` : "New Entry"}</h3>

                            <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr", gridGap: "16px", padding: "8px" }}>
                                {(this.state.newEntry) && (
                                    <div key="key" style={{ marginBottom: "8px" }}>
                                        <label htmlFor="key" className="form-label" style={{ marginBottom: "8px", display: "block", fontWeight: "bold" }}>
                                            {settings.key + (" (Key)")}:
                                        </label>
                                        <input
                                            type="text"
                                            id="key"
                                            name="key"
                                            value={this.state.entry.key}
                                            onChange={this.handleChange}
                                            className="form-input"
                                            style={{
                                                padding: "8px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </div>
                                )}
                                {Object.keys(this.state.entry)
                                    .filter(key => key !== "key")
                                    .map((key) => (
                                        <div key={key} style={{ marginBottom: "8px" }}>
                                            <label htmlFor={key} className="form-label" style={{ marginBottom: "8px", display: "block", fontWeight: "bold" }}>
                                                {key}:
                                            </label>
                                            <input
                                                type="text"
                                                id={key}
                                                name={key}
                                                value={this.state.entry[key]}
                                                onChange={this.handleChange}
                                                className="form-input"
                                                style={{
                                                    padding: "8px",
                                                    borderRadius: "4px",
                                                    border: "1px solid #ccc",
                                                    width: "100%",
                                                    boxSizing: "border-box"
                                                }}
                                            />
                                        </div>
                                    ))}
                            </div>

                            <div className="error" style={{ color: "red", marginBottom: "16px" }}>{this.state.error}</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="button confirm" onClick={this.confirmEditEntry} title="Confirm Changes" style={{ padding: "8px 16px", backgroundColor: "#27ae60", color: "#fff", borderRadius: "4px", cursor: "pointer" }}>
                                    Confirm
                                </div>
                                <div className="button delete" onClick={this.confirmDeleteEntry} title="Delete Entry" style={{ padding: "8px 16px", backgroundColor: '#c0392b', color: "#fff", borderRadius: "4px", cursor: "pointer" }}>
                                    Delete
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            var entryList = []
            var tableHeaders = ""


            //var displayFields = ["Employee Name", "BSCID", "TRADE", "Shop"]
            // Calculate average string length for each field
            // Calculate average string length for each field
            const averageLengths = {};
            for (const field of displayFields) {
                const totalLength = entries.reduce((sum, entry) => sum + (entry[field] ? entry[field].length : 0), 0);
                averageLengths[field] = totalLength / entries.length;
            }

            // Define a function to calculate width based on average length
            const calculateWidth = (length) => {
                const minWidth = 150; // Increased minimum width in pixels
                const maxWidth = 600; // Maximum width in pixels
                const factor = 15; // Increased factor to scale the width

                const width = length * factor;
                return `${Math.min(Math.max(width, minWidth), maxWidth)}px`;
            };

            // Create a widths object based on averageLengths
            const columnWidths = {};
            displayFields.forEach(field => {
                columnWidths[field] = calculateWidth(averageLengths[field]);
            });

            // Set a maximum number of headers to display
            const maxHeaders = 5;

            tableHeaders = (
                <tr className="dataRow">
                    {displayFields.slice(0, maxHeaders).map((field, index) => (
                        <th
                            key={index}
                            style={{ minWidth: columnWidths[field], cursor: 'pointer', textAlign: index === displayFields.length - 1 ? 'right' : 'left' }}
                            onClick={this.sort(field)}
                        >
                            {(field === "key") ? settings.key : field} {this.filterIcon(field)}
                        </th>
                    ))}
                </tr>
            );

            for (var entry of entries) {
                entryList.push(
                    <tr className="dataRow" onClick={this.editEntry(JSON.parse(JSON.stringify(entry)))} key={entry["BSCID"]}>
                        {displayFields.slice(0, maxHeaders).map((field, index) => (
                            <td
                                key={index}
                                style={{ minWidth: columnWidths[field], textAlign: index === displayFields.length - 1 ? 'right' : 'left' }}
                            >
                                {entry[field]}
                            </td>
                        ))}
                    </tr>
                );
            }

            // Render the table
            //     tableHeaders = (<tr className="dataRow">
            //         <th style={{ minWidth: '600px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
            //         <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'center' }} onClick={this.sort("system")}>System {this.filterIcon("system")}</th>
            //     </tr>)
            //     for (var entry of entries) {
            //         entryList.push(
            //             <tr className="dataRow" onClick={this.editEntry(JSON.parse(JSON.stringify(entry)))} key={entry.id}>
            //                 <td style={{ minWidth: '600px', textAlign: 'left' }}>{entry.name}</td>
            //                 <td style={{ minWidth: '200px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            //                     {entry.system ?
            //                         <div style={{
            //                             backgroundColor: '#2A6AA9',
            //                             color: 'white',
            //                             borderRadius: '50%',
            //                             height: '20px',
            //                             width: '20px',
            //                             display: 'flex',
            //                             justifyContent: 'center',
            //                             alignItems: 'center'
            //                         }}>
            //                             <svg width="10" height="8" viewBox="0 0 10 8">
            //                                 <path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path>
            //                             </svg>
            //                         </div>
            //                         : null
            //                     }
            //                 </td>
            //             </tr>
            //         );
            //     }
            // }
            var addButton = <img src={this.props.img.plus} className="plusButton" alt="Add a User" onClick={this.add} />

            return (
                <div style={{ width: '100%' }}>
                    {addButton}
                    <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
                        <div style={{ width: '220px', marginRight: '20px', marginTop: '10px', flexShrink: 0 }}>
                            <div className="filterBox" style={{ width: '200px' }}>
                                <h4>Filter By:</h4>
                                {displayFields.map((field, index) => (
                                    <div key={index} >
                                        <label>{(field === "key") ? settings.key : field}:</label>
                                        <input
                                            type="text"
                                            onChange={this.filter(field)}
                                            value={this.state.filterBy[field.toLowerCase().replace(/ /g, "")]}
                                            style={{ width: '150px', marginRight: '25px' }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div style={{ flex: 1, overflowX: 'auto', maxWidth: 'calc(100% - 240px)' }}>
                            <table style={{ width: '100%', tableLayout: 'fixed' }}>
                                <thead>
                                    {tableHeaders}
                                </thead>
                                <tbody>
                                    {entryList}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {editEntry}
                </div>
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}

const icon = "menuWorkflow"
const roles = ["View"]
export { GCTable, icon, roles }




function generateUniqueId() {
    const timestamp = Date.now().toString(36);
    const randomStr = Math.random().toString(36).slice(2);
    const uniqueId = timestamp + randomStr;
    return uniqueId;
}